<template>
  <div
    class="chat-input-area"
    :class="{
      'private-chat-wrap': privateSession,
      'chat-input-popup': isChatPopup,
    }"
  >
    <!-- 老师没有禁言状态（助教、学生才有） -->
    <div class="shut-up-tips" v-if="isShutUp && !userInfo.isTeacher">
      禁言中
    </div>
    <template v-else>
      <div class="input-actions">
        <div v-if="!privateSession" class="chat-to-select">
          <span class="tips-text">发送至</span>
          <el-popover
            placement="top-start"
            trigger="click"
            popper-class="member-select-popover"
            :visible-arrow="false"
            v-model="showMemberSelect"
          >
            <template #reference>
              <div
                class="selected-member"
                :class="{ 'private-chat': isPrivateChat }"
              >
                <!-- 私聊 -->
                <template v-if="isPrivateChat">
                  <span
                    v-if="selectedMember.user_role !== 3"
                    class="role-tag"
                    :class="getRoleClass(selectedMember.user_role)"
                  >
                    {{ getRoleLabel(selectedMember.user_role) }}
                  </span>
                  <el-avatar
                    v-else
                    :src="selectedMember.avatar"
                    class="member-avatar"
                  >
                  </el-avatar>
                  <div class="member-info">
                    <span class="member-name">
                      {{ selectedMember.nickname }}
                    </span>
                  </div>
                </template>
                <!-- 所有人 -->
                <template v-else>
                  <p class="all-member">
                    <img
                      src="../../../assets//images/live-chat/all-icon.png"
                      alt=""
                    />
                    <span>所有人</span>
                  </p>
                </template>
                <i
                  class="el-icon-arrow-down"
                  :class="{ 'is-reverse': showMemberSelect }"
                ></i>
              </div>
            </template>
            <member-select
              :userInfo="userInfo"
              :groupSessionId="groupSessionId"
              :showMemberSelect="showMemberSelect"
              @select="handleMemberSelect"
              :initialSelectedMember="selectedMember"
            />
          </el-popover>
        </div>

        <div class="opetion-btns">
          <face-plugin
            class="opetion-btn"
            :isMute="isShutUp"
            :faceIcon="
              require('../../../assets/images/live-chat/face-icon.png')
            "
            @select="selectFace"
          ></face-plugin>
          <image-plugin
            :isMute="isShutUp"
            class="image-plugin opetion-btn"
            @select="(file) => selectImage(file, 'select')"
          ></image-plugin>
          <img
            v-if="chatMode === 'popup'"
            src="../../../assets/images/live-chat/folder-icon.png"
            alt=""
            @click="handleFileClick"
          />
          <file-plugin
            v-else
            ref="filePlugin"
            class="file-plugin opetion-btn"
            :fileIcon="
              require('../../../assets/images/live-chat/folder-icon.png')
            "
            @select="selectFile"
            :isMute="isShutUp"
            :onClick="handleFileClick"
          ></file-plugin>
          <template v-if="!privateSession">
            <LoadingButton
              v-if="userInfo.isTeacher || userInfo.isAssistant"
              :is-active="allShutUp"
              @click-async="handleForbidClick"
              ref="forbidBtnRef"
            >
              <template v-slot:active-icon>
                <img
                  src="../../../assets/images/live-chat/forbid-open-icon.png"
                  alt="已禁言"
                />
              </template>
              <template v-slot:inactive-icon>
                <img
                  src="../../../assets/images/live-chat/Forbid-icon.png"
                  alt="非禁言"
                />
              </template>
            </LoadingButton>
            <el-tooltip
              v-else
              popper-class="live-room-tooltip"
              effect="dark"
              content="只看老师"
              placement="top"
            >
              <LoadingButton
                :is-active="onlyShowTeacher"
                @click-async="handleOnlyShowTeacher"
                ref="onlyTeacherBtnRef"
              >
                <template v-slot:active-icon>
                  <img
                    src="../../../assets/images/live-chat/only-teacher-active.png"
                    alt="只看老师"
                  />
                </template>
                <template v-slot:inactive-icon>
                  <img
                    src="../../../assets/images/live-chat/only-teacher.png"
                    alt="看所有"
                  />
                </template>
              </LoadingButton>
            </el-tooltip>
          </template>
        </div>
      </div>
      <div>
        <div
          class="editor-container"
          :class="{
            'has-quote-message': !!replayMessage,
          }"
        >
          <quillEditor
            :disabled="isShutUp"
            ref="quill"
            class="quill-editor"
            v-model="message"
            :options="editorOption"
            @focus="isFocus = true"
            @blur="isFocus = false"
            @change="onEditorChange($event)"
          />
        </div>
        <div class="send-button-container">
          <button
            class="send-button"
            @click.stop="handleSendMsg"
            :disabled="!message.trim() || isShutUp"
          >
            发送
          </button>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import LoadingButton from "@saas/pages/src/live/qick-msg-list/LoadingButton.vue";
import { getRoster } from "@saas/service-api/src/live-sdk";
import { mapState, mapGetters } from "vuex";
import { emojiUrl } from "@saas/components/src/utils/im/emoji-map";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import FacePlugin from "@saas/pages/src/chat/plugin-components/face/Face.vue";
import ImagePlugin from "@saas/pages/src/chat/plugin-components/image/index.js";
import MemberSelect from "./MemberSelect.vue";
import FilePlugin from "@saas/pages/src/chat/plugin-components/file/index.js";
import MessageQuote from "../message-components/MessageQuote.vue";
import Vue from "vue"; // 添加Vue导入
export default {
  name: "ChatInput",
  data() {
    return {
      message: "",
      selectedMember: "all",
      showMemberSelect: false,
      editorOption: {
        placeholder: "说点什么",
        theme: "snow",
        readOnly: false, // 确保不是只读模式
        modules: {
          keyboard: {
            bindings: {
              enter: {
                key: 13,
                handler: () => {
                  this.handleSendMsg();
                },
              },
              ctrlEnter: {
                key: 13,
                ctrlKey: true,
                handler: () => {
                  this.newLine();
                },
              },
            },
          },
          clipboard: {
            matchers: [
              ["img", this.desMatcherImage],
              [
                "video",
                () => {
                  return { ops: [] };
                },
              ],
            ],
          },
          toolbar: false, // 禁用工具栏，确保不会干扰输入
        },
        // debug: "info", // 启用调试信息
      },
      limitLength: 1000,
      isSending: false, // 是否正在发送消息
      isFocus: false,
      quoteInstance: null, // 引用消息组件实例
      emojiErrorTimer: null, // 表情错误提示防抖计时器
      emojiLimit: 20, // 表情数量限制
      isChatPopup: false,
    };
  },
  created() {},

  mounted() {
    EventBus.$off("chat-all-shutup-end");
    EventBus.$on("chat-all-shutup-end", this.onChatAllShutupEnd);
    setTimeout(() => {
      this.quillFocus();
    }, 1000);
    document.addEventListener("drop", this.ondrop);
    this.isChatPopup = this.$route.name === "ChatPopup";
    if (window.ipcRenderer) {
      window.ipcRenderer.on(
        "chat-select-file-result",
        this.onChatSelectFileResult
      );
    }
  },
  beforeDestroy() {
    document.removeEventListener("drop", this.ondrop);
    // 清理防抖计时器
    if (this.emojiErrorTimer) {
      clearTimeout(this.emojiErrorTimer);
      this.emojiErrorTimer = null;
    }
    if (window.ipcRenderer) {
      window.ipcRenderer.removeListener(
        "chat-select-file-result",
        this.onChatSelectFileResult
      );
    }
    EventBus.$off("chat-all-shutup-end", this.onChatAllShutupEnd);
  },
  watch: {
    initSelectedMember: {
      handler(newValue) {
        this.selectedMember = newValue;
      },
      immediate: true,
    },
    message: {
      // 当inputValue变化时，同步给父组件
      handler(newValue) {
        this.$emit("input-change", newValue);
      },
    },
    input: {
      handler(newValue) {
        if (newValue !== this.message) {
          this.message = newValue;
        }
      },
      immediate: true,
    },
    // 监听store中的replayMessage变化
    replayMessage: {
      handler(newValue, oldValue) {
        if (newValue?.ID && newValue?.ID !== oldValue?.ID) {
          this.showQuoteMessage(newValue);
          this.quillFocus();
        } else if (!newValue?.ID) {
          this.hideQuoteMessage();
          this.quillFocus();
        }
      },
      deep: true,
      immediate: true,
    },
    showChat: {
      handler(newValue) {
        if (newValue) {
          this.quillFocus();
        }
      },
    },
  },
  computed: {
    ...mapGetters("live", ["isShutUp", "allShutUp"]), //当前用户是否被禁言
    ...mapState("newChat", [
      "haveMaterialPermission",
      "replayMessage",
      "onlyShowTeacher",
      "showChat",
      "currentSession",
      "chatMode",
    ]),
    ...mapState("live", ["userStatus", "roomInfo"]),
    isPrivateChat() {
      return this.selectedMember !== "all";
    },
  },
  props: {
    input: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    groupSessionId: {
      type: String,
      default: "",
    },
    initSelectedMember: {
      type: [Object, String],
      default: "all",
    },
    privateSession: {
      type: Boolean,
      default: false, // 是否是私聊
    },
  },
  components: {
    quillEditor,
    FacePlugin,
    ImagePlugin,
    MemberSelect,
    FilePlugin,
    LoadingButton,
  },
  methods: {
    onChatSelectFileResult(event, params) {
      console.log("chat-select-file-result", params);
      this.selectFile(params);
    },
    onChatAllShutupEnd() {
      if (this?.$refs?.forbidBtnRef?.setLoading) {
        this.$refs.forbidBtnRef.setLoading(false);
      }
    },
    // 拖拽插入图片
    ondrop(e) {
      const html = e.dataTransfer.getData("text/html");
      const path = e.path || (e.composedPath && e.composedPath());
      path.forEach((item) => {
        if (item.className && item.className.indexOf("ql-editor") !== -1) {
          return false;
        }
      });
      const isEditor = path.some((item) => {
        return item.className.indexOf("ql-editor") !== -1;
      });
      if (isEditor) {
        setTimeout(() => {
          if (this.$refs.quill) {
            // 编辑器插入拖拽的html
            const index = this.getIndex();
            this.$refs.quill.quill.clipboard.dangerouslyPasteHTML(index, html);
          }
        }, 100);
      }
      e.preventDefault();
    },
    quillFocus() {
      this.$nextTick(() => {
        if (this?.$refs?.quill?.quill?.setSelection) {
          this.$refs.quill.quill.setSelection(this.message.length);
        }
      });
    },
    handleForbidClick() {
      const callback = () => {
        if (this?.$refs?.forbidBtnRef?.setLoading) {
          this.$refs.forbidBtnRef.setLoading(false);
        }
      };
      this.$emit("forbid-click", callback);
    },
    handleOnlyShowTeacher() {
      const callback = () => {
        if (this?.$refs?.onlyTeacherBtnRef?.setLoading) {
          this.$refs.onlyTeacherBtnRef.setLoading(false);
        }
      };
      this.$emit("only-show-teacher", callback);
    },
    // 显示引用消息
    async showQuoteMessage(message) {
      // 如果已经有引用消息实例，先销毁它
      this.hideQuoteMessage();

      // 引用私聊：修改发送至为私聊对象
      if (message.isPrivateMsg === 1) {
        let user_id = "";
        if (message.flow === "out") {
          user_id = message?.privateInfo?.to?.id;
        } else {
          user_id = message?.privateInfo?.from?.id;
        }
        if (!user_id) return;
        const params = {
          user_id,
          room_id: this.groupSessionId,
          page_no: 1,
          page_size: 1,
        };
        const response = await getRoster(params);
        if (response && response.data?.list?.length) {
          this.selectedMember = response.data.list[0];
        }
      }

      // 创建引用消息组件
      const QuoteConstructor = Vue.extend(MessageQuote);
      this.quoteInstance = new QuoteConstructor({
        propsData: {
          quoteMessage: message,
          showCloseButton: true,
        },
        parent: this, // 确保组件能够访问父组件的上下文
      });

      // 监听取消引用事件
      this.quoteInstance.$on("cancel-quote", this.clearQuoteMessage);

      // 挂载组件到DOM
      this.quoteInstance.$mount();

      this.$nextTick(() => {
        // 确保quill编辑器已经加载
        if (this.$refs?.quill?.$el) {
          // 查找quill编辑器的容器
          const quillContainer =
            this.$refs.quill.$el.querySelector(".ql-container");

          if (quillContainer) {
            // 创建一个容器div来放置引用消息组件
            const quoteContainer = document.createElement("div");
            quoteContainer.className = "quote-container";

            // 清空容器并添加引用消息组件
            quoteContainer.appendChild(this.quoteInstance.$el);

            // 将引用消息容器插入到quill容器的最后一个子元素后
            quillContainer.appendChild(quoteContainer);
          } else {
            console.error("==zy==找不到.ql-container元素");
          }
        } else {
          console.error("==zy==找不到quill编辑器引用");
        }
      });
    },

    // 隐藏引用消息
    hideQuoteMessage() {
      if (this.quoteInstance) {
        this.quoteInstance.$destroy();

        // 查找并移除引用消息容器
        if (this.$refs.quill && this.$refs.quill.$el) {
          const quoteContainer =
            this.$refs.quill.$el.querySelector(".quote-container");
          if (quoteContainer && quoteContainer.parentNode) {
            quoteContainer.parentNode.removeChild(quoteContainer);
          }
        }

        this.quoteInstance = null;
      }
    },

    // 清除引用消息
    clearQuoteMessage() {
      this.$store.commit("newChat/SET_REPLAY_MESSAGE", null);
    },

    // 编辑器换行
    newLine() {
      this.$refs.quill.quill.insertText(this.getIndex(), "\n");
    },
    handleSendMsg() {
      if (!this.message) {
        return;
      }

      // 检查是否被禁言
      if (this.isShutUp) {
        this.$darkMessage.error("您已被禁言，无法发送消息");
        return;
      }

      // 检查是否正在发送消息，防止重复发送
      if (this.isSending) {
        return;
      }

      this.isSending = true;
      const msgList = this.formatSendMessage() || [];
      msgList.forEach((item) => {
        if (item.content === "\n" || !item.content) {
          return;
        }
        if (item.type === "image" && item.content.startsWith("data:image")) {
          this.selectImage(item, "editor");
        } else if (item.type === "text") {
          // 发送文本
          this.sendRequest(item.content);
        } else if (item.type === "image") {
          this.selectImage(item, "editor");
        }
      });
      this.message = "";
      this.isSending = false;
    },
    sendRequest(msgText) {
      if (!msgText.trim()) {
        this.$darkMessage.error("不能发送空消息");
        return;
      }
      this.handleSendMessage({
        type: "text",
        data: msgText.replace(/\n$/, ""), //去掉末尾的换行符
      });
    },
    handleSendMessage(data) {
      let cloudCustomData = {};
      if (this.isPrivateChat || this.privateSession) {
        let to = {};
        if (this.privateSession) {
          const { name, user_id, user_role } = this.currentSession;
          to = {
            id: user_id,
            name,
            userRole: user_role,
          };
        } else {
          const { user_id, nickname, user_role } = this.selectedMember;
          to = {
            id: user_id,
            name: nickname,
            userRole: user_role,
          };
        }

        cloudCustomData = {
          isPrivateMsg: 1,
          privateInfo: {
            from: {
              id: this.userInfo.user_id,
              name: this.userStatus.nickname,
              userRole: this.userInfo.user_role,
            },
            to,
          },
        };
      }

      // 如果有引用消息，添加到cloudCustomData中
      if (this.replayMessage) {
        const {
          ID,
          time,
          from,
          to,
          nick,
          avatar,
          sequence,
          type,
          payload,
          showContext,
          isPrivateMsg,
          privateInfo,
        } = this.replayMessage;
        cloudCustomData.replyMsg = {
          time,
          msgId: ID,
          from,
          to,
          nick,
          avatar,
          sequence,
          convType: "group",
          type,
        };
        if (type === "image") {
          const { url, width, height } = showContext;
          cloudCustomData.replyMsg = {
            ...cloudCustomData.replyMsg,
            imageWidth: width,
            imageHeight: height,
            imgUrl: url,
          };
        } else if (type === "file") {
          const { name } = showContext;
          cloudCustomData.replyMsg = {
            ...cloudCustomData.replyMsg,
            fileName: name,
          };
        } else if (type === "text") {
          const { text } = payload;
          cloudCustomData.replyMsg = {
            ...cloudCustomData.replyMsg,
            text,
          };
        }

        // 引用的是私聊信息
        if (isPrivateMsg === 1) {
          const { id, name } = privateInfo?.to || {};
          cloudCustomData.replyMsg = {
            ...cloudCustomData.replyMsg,
            to: id,
            toNick: name,
            convType: "c2c",
          };
        }
      }
      // 在这判断添加课时id
      // cloudCustomData.lessonId = this.roomInfo.lesson_id;
      this.$emit("send", {
        ...data,
        cloudCustomData:
          JSON.stringify(cloudCustomData) === "{}"
            ? ""
            : JSON.stringify(cloudCustomData),
      });
      this.clearQuoteMessage(); // 发送后清除引用消息
    },
    // 格式化编辑器的数据
    formatSendMessage() {
      const messageContents = this.$refs.quill.quill.getContents().ops;
      const condition = (item) =>
        item.insert.image && !item.insert.image.startsWith(emojiUrl);
      const res = this.splitArrayByCondition(messageContents, condition);
      return this.concatMessage(res);
    },
    splitArrayByCondition(arr, condition) {
      const result = [];
      let currentSubArray = [];

      arr.forEach((element, index) => {
        if (condition(element)) {
          result.push(currentSubArray);
          // 当前元素满足条件，结束当前子数组并开始新的子数组
          currentSubArray = [element];
          result.push(currentSubArray);
          currentSubArray = [];
        } else {
          // 当前元素不满足条件，继续添加到当前子数组
          currentSubArray.push(element);
        }
        if (index === arr.length - 1) {
          // 处理最后一个元素
          result.push(currentSubArray);
        }
      });

      return result;
    },
    // 拼接消息
    concatMessage(msgList) {
      const res = msgList.map((subList) => {
        let message = {
          content: "",
          type: "",
        };
        subList.forEach((item) => {
          if (item.insert.image && item.insert.image.startsWith(emojiUrl)) {
            const url = item.insert.image;
            // 移除URL参数，只保留文件名部分
            const cleanUrl = url.split("?")[0];
            const fileName = cleanUrl.replace(emojiUrl, "");
            // 直接提取文件名（不含扩展名）
            const emojiName = fileName.replace(/\.gif|\.png/g, "");
            const name = `[${emojiName}]`;
            message.content += decodeURIComponent(name);
            message.type = "text";
            // 发送图片
          } else if (typeof item.insert === "string") {
            // 发送文本
            message.content += item.insert;
            message.type = "text";
          } else if (
            item.insert.image &&
            !item.insert.image.startsWith(emojiUrl)
          ) {
            message.content += item.insert.image;
            message.type = "image";
          }
        });
        return message;
      });
      return res;
    },
    onEditorChange(event) {
      const currentlength = this.$refs.quill.quill.getLength() - 1;
      if (this.limitLength && currentlength >= this.limitLength) {
        this.$refs.quill.quill.deleteText(this.limitLength, 2000000);
      }
    },
    // 统计当前编辑器中的表情数量
    getCurrentEmojiCount() {
      const messageContents = this.$refs.quill.quill.getContents().ops;
      return messageContents.filter(
        (item) =>
          item.insert &&
          item.insert.image &&
          item.insert.image.startsWith(emojiUrl)
      ).length;
    },
    // 判断插入表情是否超限
    canInsertEmojis(addCount = 1) {
      return this.getCurrentEmojiCount() + addCount <= this.emojiLimit;
    },
    // 防抖的错误提示
    showEmojiError() {
      if (this.emojiErrorTimer) clearTimeout(this.emojiErrorTimer);
      this.emojiErrorTimer = setTimeout(() => {
        this.$darkMessage.error({
          message: `表情数量不能超过${this.emojiLimit}个`,
          duration: 2000,
        });
        this.emojiErrorTimer = null;
      }, 100);
    },
    selectFace(face) {
      if (!this.canInsertEmojis(1)) {
        this.showEmojiError();
        return;
      }
      const index = this.getIndex();
      this.$refs.quill.quill.insertEmbed(index, "image", face.url);
      this.$refs.quill.quill.setSelection(index + 1);
      this.addFaceStyle(face.url);
    },
    // 给编辑器里面表情添加样式
    addFaceStyle(imageUrl) {
      const imgElements = this.$refs.quill.$el.querySelectorAll(
        `img[src="${imageUrl}"]`
      );
      imgElements.forEach((img) => {
        img.style.maxWidth = "20px";
        img.style.maxHeight = "20px";
        img.style.display = "inline-block";
      });
    },
    // 获取编辑器光标位置
    getIndex() {
      return this.$refs.quill.quill.selection.savedRange.index; // 获取光标位置
    },
    // 判断文件大小
    isFileSize(file) {
      return file.size / 1024 / 1024;
    },
    selectImage(file, type) {
      try {
        if (this.isShutUp) {
          this.$darkMessage.error("您已被禁言，无法发送图片");
          return;
        }
        if (type !== "editor") {
          // 判断文件是否为图片类型
          const isImage = file.type.startsWith("image/");
          if (!isImage) {
            this.$darkMessage.error("请发送图片");
            return;
          }
          if (this.isFileSize(file) > 32) {
            this.$darkMessage.error("图片大小不能超过32M");
            return;
          }
        } else {
          file.name = file.name || "image.png";
        }
        this.handleSendMessage({
          type: "image",
          data: file,
        });
      } catch (error) {
        console.log("selectImage", error);
      }
    },
    selectFile(val) {
      try {
        const { file, type } = val;
        if (type === "sdk") {
          if (this.isFileSize(file) > 100) {
            this.$darkMessage.error("文件大小不能超过100M");
            return;
          }
          this.handleSendMessage({
            type: "file",
            data: {
              file,
            },
          });
        } else {
          // 通过自定义消息类型发送
          const data = {
            msg_source: 1, // 素材库
            url_path: file.url_path,
            file_size: file.file_size,
            file_name: file.material_name + (file.file_ext || ""),
            file_uuid: file.id + "",
          };
          this.handleSendMessage({
            type: "file",
            data: {
              file: data,
              source: "material",
            },
          });
        }
      } catch (error) {
        console.log("selectFile", error);
      }
    },
    handleMemberSelect(member) {
      this.selectedMember = member;
      this.showMemberSelect = false;
      this.$emit("select-member", member);
      if (!this.replayMessage) {
        return;
      }
      const { isPrivateMsg, privateInfo, flow } = this.replayMessage;
      // 当前引用的是私聊消息且发送至不是当前引用私聊对象，则清除引用消息
      if (isPrivateMsg === 1) {
        if (flow === "in") {
          if (privateInfo?.from?.id !== member.user_id) {
            this.clearQuoteMessage();
          }
        } else {
          if (privateInfo?.to?.id !== member.user_id) {
            this.clearQuoteMessage();
          }
        }
      }
    },

    // 根据角色获取对应的标签文本
    getRoleLabel(role) {
      const roleMap = {
        1: "教师",
        2: "助教",
        3: "学生",
      };
      return roleMap[role] || "";
    },

    // 根据角色获取对应的样式类名
    getRoleClass(role) {
      const classMap = {
        1: "role-teacher",
        2: "role-assistant",
        3: "role-student",
      };
      return classMap[role] || "";
    },
    handleFileClick(event) {
      if (this.userInfo.user_role === 3) {
        // 学生
        this.$refs.filePlugin.showFileUpload();
      } else {
        if (this.haveMaterialPermission) {
          if (this.chatMode === "popup") {
            // 通知直播间窗口打开文件上传弹窗
            window.ipcRenderer?.send("chat-select-file");
          } else {
            this.$refs.filePlugin.handleUpload();
          }
        } else {
          this.$refs.filePlugin.showFileUpload();
        }
      }
    },
    // 粘贴图片拦截
    desMatcherImage(node, Delta) {
      let res = Delta;
      // 统计本次粘贴要插入多少个表情
      const pasteEmojis = (Delta.ops || []).filter(
        (item) =>
          item.insert &&
          item.insert.image &&
          item.insert.image.startsWith(emojiUrl)
      ).length;
      if (!this.canInsertEmojis(pasteEmojis)) {
        this.showEmojiError();
        return { ops: [] };
      }
      // 正常处理
      if (Delta.ops && Delta.ops.length > 0) {
        Delta.ops.forEach((item) => {
          if (item.insert.image && item.insert.image.startsWith(emojiUrl)) {
            this.$nextTick(() => {
              this.addFaceStyle(item.insert.image);
            });
          }
        });
      }
      return res;
    },
  },
};
</script>
<style lang="scss" scoped>
$option-icon-size: 20px;
$option-icon-margin-left: 10px;
$quill-editor-height: 150px;
$quill-editor-height-popup: 60px;
.chat-input-area {
  border-top: 1px solid #27272a;
  height: calc($quill-editor-height + 100px);
  display: flex;
  flex-direction: column;
  &.private-chat-wrap ::v-deep .face {
    .face-main {
      left: 0 !important;
    }
  }
  .input-actions {
    padding: 12px 16px 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .selected-member {
      width: 113px;
      max-width: 113px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      color: #f7f8fa;
      font-weight: 400;
      font-size: 12px;
      background: #3f3f45;
      border-radius: 6px;
      padding: 0 4px 0 6px;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      position: relative;

      .all-member {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 12px;
        color: #f7f8fa;
        line-height: 20px;
        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }

      &.private-chat {
        .member-avatar {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
        .role-tag {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 2px;
          border-radius: 3px;
          font-weight: 500;
          font-size: 8px;
          color: #17c964;
          line-height: 1;
          height: 12px;
          background: #052814;
          margin-right: 4px;
          &.role-student {
            display: none;
          }
          &.role-assistant {
            color: #006fee;
            background: #001731;
          }
        }
        .member-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          overflow: hidden;
          // margin-right: 16px; /* Space for close icon */

          .member-name {
            color: #fff;
            font-size: 12px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-break: anywhere;
          }
        }
      }

      .el-icon-arrow-down {
        font-size: 12px;
        color: #86909c;
        margin-left: 4px;
        flex-shrink: 0;
        font-weight: bold;
        transition: transform 0.3s ease;

        &.is-reverse {
          transform: rotate(180deg);
        }
      }
    }

    .opetion-btns {
      display: flex;
      align-items: center;
      .opetion-btn:first-child ::v-deep {
        img {
          margin-left: 0;
        }
      }
      img {
        width: $option-icon-size;
        height: $option-icon-size;
        margin-left: $option-icon-margin-left;
      }
    }
  }

  .chat-to-select {
    display: flex;
    align-items: center;
    .tips-text {
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      line-height: 20px;
      margin-right: 10px;
    }
  }

  ::v-deep .face {
    & > img {
      width: $option-icon-size;
      height: $option-icon-size;
      margin-left: $option-icon-margin-left;
    }
    .face-main {
      width: 245px;
      left: auto !important;
      top: -260px;
      right: 0;
      z-index: 10;
      background: #18181b;
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
      border: 1px solid rgba(229, 231, 235, 0.04);
      .face-list {
        &::-webkit-scrollbar-thumb {
          background-color: #27272a;
        }
      }
    }
  }
  .image-plugin {
    position: relative;
    overflow: hidden;
    background-image: url("../../../assets/images/live-chat/pic-icon.png");
    width: $option-icon-size;
    height: $option-icon-size;
    margin-left: $option-icon-margin-left;
    margin-right: 0;
    cursor: pointer;
  }
  ::v-deep .file-plugin {
    & > img {
      width: $option-icon-size;
      height: $option-icon-size;
      margin-left: $option-icon-margin-left;
      margin-right: 0;
    }
  }

  .shut-up-tips {
    font-weight: 500;
    font-size: 14px;
    color: #86909c;
    line-height: 20px;
    padding: 16px;
  }
  .quill-editor {
    // margin-left: 6px;
    // flex: 1;
    // width: 0;
    ::v-deep .ql-container {
      border: none;
      height: $quill-editor-height; //高度设置-可自动滚动

      /* 引用消息容器样式 */
      .quote-container {
        position: relative;
        left: -8px;
        max-width: calc(100% + 8px);
      }

      .ql-editor {
        min-height: 100%;
        max-height: 100%;
      }
      &.ql-snow {
        border: none;
        border-radius: 0;
      }
      .ql-editor {
        // font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 24px;
        // height: 24px;
        padding: 0 !important;
        overflow-x: hidden;
        overflow-y: auto;
        // scroll-snap-type: x mandatory;
        // scroll-behavior: smooth;
        scrollbar-width: 0;
        /* 标准语法，Firefox 支持 */
        -ms-overflow-style: none;
        /* IE 和 Edge */
        &::-webkit-scrollbar {
          display: none;
          /* WebKit 内核浏览器 */
        }
        &::before {
          font-style: normal;
          left: 0;
        }
        p,
        span,
        div {
          background-color: unset !important;
          word-break: break-all;
        }
        img {
          max-width: 100%;
          background-color: unset !important;
        }
        &.ql-blank {
          height: 100%;
          &::before {
            color: #86909c;
            font-weight: 400;
            font-size: 14px;
          }
        }
        &::before {
          color: #86909c;
          font-weight: 500;
          font-size: 14px;
        }
      }
    }
    ::v-deep .ql-toolbar {
      display: none;
    }
  }

  .editor-container {
    // flex: 1;
    // position: relative;
    padding: 0 16px;
    margin: 12px 0 0 0;
    &.has-quote-message {
      margin-bottom: 35px;
      ::v-deep .ql-editor,
      .ql-blank {
        min-height: auto;
        height: auto !important;
      }
      .quill-editor {
        ::v-deep .ql-container {
          height: calc($quill-editor-height - 35px);
        }
      }
    }
  }
  .send-button-container {
    display: flex;
    justify-content: flex-end;
  }
  .send-button {
    // position: absolute;
    // right: 12px;
    // bottom: 12px;
    // z-index: 10;
    width: 40px;
    height: 24px;
    background: rgba(39, 39, 42, 0.4);
    border-radius: 8px 8px 8px 8px;
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    // border: none;
    margin: 12px;
    &:disabled {
      background: rgba(39, 39, 42, 0.4);
      color: #4e5969;
      opacity: 1;
    }
  }
}
.chat-input-popup {
  height: calc($quill-editor-height-popup + 88px);
  .quill-editor {
    ::v-deep .ql-container {
      height: $quill-editor-height-popup; //高度设置-可自动滚动
    }
  }
  .editor-container.has-quote-message {
    margin-bottom: 35px;
    .quill-editor {
      ::v-deep .ql-container {
        height: calc($quill-editor-height-popup - 35px);
      }
    }
  }
  .send-button-container {
    height: 24px;
  }
  .send-button {
    margin-top: 0px;
  }
}
</style>

<style lang="scss">
.member-select-popover {
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  margin-top: 4px !important;

  .el-popover__title {
    display: none;
  }

  .popper__arrow {
    display: none !important;
  }
}
</style>
